<!-- header -->
<app-header />
<!-- failure messages -->
@if (configParams?.isBrazilBankRegEnabled && depositService.showDeclinePage()) {
    <app-deposit-declined />
}
@if (!depositService.showDepositSuccess() && depositService.showDepositFailure() && !depositService.showDeclinePage()) {
    <app-deposit-failure />
}
<!-- additional messages like ada,arc,curfew,reversal etc.. -->
@if (!depositService.showDepositSuccess() && !dataService.depositProcess()) {
    <app-additional-messages
        [selectedOption]="selectedOption"
        [class.d-none]="depositService.showDeclinePage()"
        (activeDepositCurfewInfo)="getActiveDepositCurfew($event)" />
}
@if (depositService.showDepositInput()) {
    <ng-container disabled="(kycPLverification && (ccFamily.includes(inputType) || inputType === 'PAYPAL')) ? true : null">
        <form
            class="cashier-form-wrapper qd-form-wrapper"
            [formGroup]="depositForm"
            (ngSubmit)="submitDeposit()"
            [class.d-none]="!depositService.showDepositInput() || dataService.depositProcess() || depositService.showDeclinePage()"
            [class.disabled]="depositService.isFormDisable()">
            <!-- payment methods input -->
            <app-options-list
                [instrumentFormGroup]="depositForm.controls.instrumentFormGroup"
                (paymentMethod)="updatePaymentMethod($event.toString())" />
            <!-- submit deposit button -->
            <!-- bottom messages -->
            @if (!depositService.showDepositSuccess() && depositService.showDepositFailure()) {
                <app-bottom-messages />
            }
            @if (!['APPLEPAY', 'APPLEPAYDIRECT'].includes(inputType)) {
                <button
                    type="submit"
                    id="btnSubmitDeposit"
                    [disabled]="getIsSubmitButtonDisabled || isSubmitClicked"
                    class="btn btn-primary w-100 mt-1">
                    {{ 'PARTY.CASHIER.web.deposit.button' | translate }}
                </button>
            } @else {
                <div class="my-1 w-100 deposit-btn float-left deposit-botton-fixed h-auto">
                    <div
                        (click)="
                            !depositForm.valid || depositCurfewCtaDisabled || loaderService.depositRedirectInProgress()
                                ? null
                                : applePayDepositSubmit()
                        "
                        class="applePayButton apple-pay-button apple-pay-button-black w-100"></div>
                </div>
            }
        </form>
    </ng-container>
}

<!-- deposit process page -->
@if (dataService.depositProcess()) {
    <app-deposit-process />
}

<!-- deposit success page -->
@if (depositService.showDepositSuccess()) {
    <app-deposit-success />
}
